import React from 'react';

import DownloadIcon from '../../assets/download-icon';
import BackButton from '../../components/back-button';
import ButtonWithIcon from '../../components/button-with-icon';
import { formattedDate } from '../../helpers/formatted';
import { API } from '../../helpers/constants';
import { useParams } from 'react-router-dom';
import Error from '../../components/error';
import useGet from '../../hook/use-get';
import LoadingDetails from './components/loading-details';

const EventDetails = () => {
  const { eventId } = useParams();
  const { data, isError, isFetching, refetch } = useGet({
    queryKey: 'eventDetails',
    api: `${API.eventDetails}/${eventId}`
  });

  const RenderContent = () => {
    if (isFetching) {
      return <LoadingDetails />;
    }

    if (isError) {
      return <Error refetch={refetch} />;
    }

    return (
      <>
        <BackButton />
        <img src={data?.['file_name']} alt="event-image" className="h-96 w-auto" />
        <h1 className="text-heading5 leading=[150%] md:text-heading2 md:leading-[100%] font-bold text-left">
          {data?.name}
        </h1>
        <h3 className="text-body1 leading-[150%] font-medium md:text-heading5 md:leading-[100%] text-left">
          {formattedDate(data?.['created_at'], { isShowDay: true })}
        </h3>
        <p className="text-body1 text-left md:leading-[150%]">{data?.description}</p>
        <div>
          <a href={data?.['link_url']} target="_blank">
            <ButtonWithIcon icon={<DownloadIcon />} text="Klik Disini" />
          </a>
        </div>
      </>
    );
  };

  return (
    <div className="bg-white py-8 md:py-16">
      <div className="w-[90%] md:w-[80%] lg:w-[50%] m-auto text-left space-y-6">
        <RenderContent />
      </div>
    </div>
  );
};

export default EventDetails;
